module.exports = __webpack_public_path__ + "img/AP_ico_info.9406c531.svg";